<script lang="ts" setup>
import type { IHeaderParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';
import Checkbox from '@/components/common/Checkbox.vue';

type ExtendedParams = IHeaderParams & {
    id: string;
    checked: ((pnarams: IHeaderParams) => boolean) | boolean;
    onChange: () => void
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const checked = computed(() => (typeof props.params.checked === 'function' ? props.params.checked(props.params) : props.params.checked));

function onChange(): void {
    props.params.onChange();
}
</script>

<template>
    <div class="flex-container align-middle align-center height-100">
        <Checkbox
            size="small"
            :checked="checked"
            @change="onChange"
        />
    </div>
</template>

<style lang="scss" scoped>
// Customized checkbox styling to match ag-grid checkbox
::v-deep(.sy-checkbox-container) {
    .sy-checkbox {
        border-radius: 2px;
        border: 2px solid var(--sy-gray-400);

        &::after {
            width: 0.3rem;
            height: 0.6rem;
            left: 0.35rem;
            top: 0.1rem;
            border-width: 0 2px 2px 0;
        }
    }

    input:checked ~ .sy-checkbox {
        background-color: #1f6df5;
    }
}
</style>
